<template>
  <AppButton
    text
    class="text-uppercase"
    v-bind="$attrs"
  >
    <!-- @slot for button text -->
    <slot></slot>
  </AppButton>
</template>

<script>
import AppButton from '@/common/buttons/AppButton.vue'

export default {
  name: 'SnackBarButton',
  components: { AppButton },
}
</script>
